import { render, staticRenderFns } from "./NeoTag.vue?vue&type=template&id=6f44ac37&scoped=true&"
import script from "./NeoTag.vue?vue&type=script&lang=js&"
export * from "./NeoTag.vue?vue&type=script&lang=js&"
import style0 from "./NeoTag.vue?vue&type=style&index=0&id=6f44ac37&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f44ac37",
  null
  
)

export default component.exports